/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 10H12M2 14H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 6.0469C18.3247 4.17845 15.8736 3 13.1429 3C8.0934 3 4 7.02944 4 12C4 16.9706 8.0934 21 13.1429 21C15.8736 21 18.3247 19.8216 20 17.9531"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M20.0002 6.0469C18.3249 4.17845 15.8738 3 13.1431 3C8.09364 3 4.00024 7.02944 4.00024 12C4.00024 16.9706 8.09364 21 13.1431 21C15.8738 21 18.3249 19.8216 20.0002 17.9531M2 10H12M2 14H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M20.0002 6.0469C18.3249 4.17845 15.8738 3 13.1431 3C8.09364 3 4.00024 7.02944 4.00024 12C4.00024 16.9706 8.09364 21 13.1431 21C15.8738 21 18.3249 19.8216 20.0002 17.9531M2 10H12M2 14H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M20.0002 6.0469C18.3249 4.17845 15.8738 3 13.1431 3C11.6319 3 10.2063 3.36093 8.95039 4M20.0002 17.9531C18.3249 19.8216 15.8738 21 13.1431 21C8.09364 21 4.00024 16.9706 4.00024 12C4.00024 10.1499 4.56738 8.4301 5.53985 7M2 10H12M2 14H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M20.0002 6.0469C18.3249 4.17845 15.8738 3 13.1431 3C8.09364 3 4.00024 7.02944 4.00024 12C4.00024 16.9706 8.09364 21 13.1431 21C15.8738 21 18.3249 19.8216 20.0002 17.9531M2 10H12M2 14H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M20.0002 6.0469C18.3249 4.17845 15.8738 3 13.1431 3C8.09364 3 4.00024 7.02944 4.00024 12C4.00024 16.9706 8.09364 21 13.1431 21C15.8738 21 18.3249 19.8216 20.0002 17.9531M2 10H12M2 14H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
